import React from 'react'
import { render } from '@testing-library/react'
import App from './App'

test('apruvd logo renders', () => {
  const { getByAltText } = render(<App />)
  const linkElement = getByAltText(/Apruvd Logo/i)
  expect(linkElement).toBeInTheDocument()
})
